<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 5.001a5.13 5.13 0 0 1 5.25-5 5.241 5.241 0 0 1 4.956 3.345c.097-.008.195-.012.294-.012A3.42 3.42 0 0 1 14 6.668a3.42 3.42 0 0 1-3.5 3.333H5.25a5.13 5.13 0 0 1-5.25-5Z" opacity=".45" fill="currentColor"/><path d="M7.001 16.001a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1v-2a4 4 0 0 1 4-4 4.007 4.007 0 0 1 4 4v2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-8Zm6-9v-2a2 2 0 1 0-4 0v2h4Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering203',
});
</script>
